/**
 * Route base for the Echo Studies (ultrasound) area.
 * Aligned with DB menu key `echos_studies` and paths `/echos_studies/...`.
 */
export const ECHOS_STUDIES_BASE_PATH = '/echos_studies';
